import React, { useState } from "react";
import { FaCar, FaHandsHelping, FaShieldAlt } from "react-icons/fa";
// Removed Carousel import since it's no longer used in the updated section
import "react-responsive-carousel/lib/styles/carousel.min.css";

// Import new images
import ex1 from "./me34.png";
import ex2 from "./ex2.png";


// Import the new image to replace the carousel
import img777 from "./777.png";

// Import the new FounderVideoSection component
import FounderVideoSection from "./FounderVideoSection";

const AboutPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    <div
      style={{
        fontFamily: "'Roboto', sans-serif",
        color: "#333",
        background: "linear-gradient(to bottom, #ffffff, #f8f8f8)",
        padding: "40px 40px",
      }}
    >
     {/* Hero Section */}
<section
  style={{
    textAlign: "center",
    marginBottom: "60px",
    background: "linear-gradient(to right, #000, #1d1e22, #000)",  // Sides fade effect for depth
    color: "white",
    padding: "30px 20px",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)"
  }}
>
  <h1 style={{ fontSize: "4em", marginBottom: "10px" }}>Welcome to Gier</h1>
  <p style={{ fontSize: "1.4em", maxWidth: "800px", margin: "auto" }}>
    Changing the way people see vehicles
  </p>
</section>

      {/* Founder Video Section */}
      <FounderVideoSection />

      {/* Story Section */}
      <section
        style={{
          maxWidth: "1200px",
          margin: "auto",
          marginBottom: "60px",
          display: "flex",
          alignItems: "center",
          gap: "40px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: "1 1 40%" }}>
          <img
            src={ex1}
            alt="Our Journey"
            style={{
              width: "100%",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            }}
          />
        </div>
        <div style={{ flex: "1 1 50%" }}>
          <h2 style={{ fontSize: "2.2em", marginBottom: "20px" }}>Who are we</h2>
          <p style={{ fontSize: "1.2em", lineHeight: "1.8" }}>
            Gier started as an idea after the CEO and Founder Jordan Dye started a success Turo Fleet. 
            After all was said and done he had accumulated 245 trips. Exactly 222 five star Reviews and 76 Personal mentions 
            by name he knew all the problems people faced with cars. Upside-down car loans, insane vehicle prices, outrageous mechanic fees and a terrible 
            car market filled with junk cars. This is when he came up with Gier. Gier was created to solve all of these issues. 
            <br /><br />
            Oh... and he also shook every single. persons. hand.
          </p>
        </div>
      </section>

      {/* 100% Real Reviews Section with Full-Width Image */}
      <section style={{ marginBottom: "60px", position: "relative" }}>
        <h2
          style={{
            fontSize: "2.5rem",
            textAlign: "center",
            color: "#000",
            marginBottom: "20px",
          }}
        >
          100% Real Reviews
        </h2>
        <img src={img777} alt="Reviews Banner" style={{ width: "100%", display: "block" }} />
      </section>

      {/* Core Principles with Icons (modified) */}
      <section
        style={{
          backgroundColor: "#007bff",
          color: "white",
          padding: "20px 10px", // Reduced padding for a thinner look
          borderRadius: "10px",
          marginBottom: "60px",
        }}
      >
        <h2 style={{ fontSize: "2.2em", textAlign: "center", marginBottom: "30px" }}>
          Our Core Principles
        </h2>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
            gap: "10px", // Reduced gap between columns
            maxWidth: "1200px",
            margin: "auto",
          }}
        >
          <div
            style={{
              flex: "1 1 30%",
              textAlign: "center",
              padding: "10px", // Reduced padding for each principle
            }}
          >
            <FaCar size={50} style={{ marginBottom: "10px" }} />
            <h3 style={{ fontSize: "1.5em", marginBottom: "10px" }}>Real World Value</h3>
            <p style={{ fontSize: "1.1em", lineHeight: "1.6" }}>
              When you Invest with us, you invest in assets that offer real value to the world.
            </p>
          </div>
          <div
            style={{
              flex: "1 1 30%",
              textAlign: "center",
              padding: "10px", // Reduced padding for each principle
            }}
          >
            <FaShieldAlt size={50} style={{ marginBottom: "10px" }} />
            <h3 style={{ fontSize: "1.5em", marginBottom: "10px" }}>Security & Transparency</h3>
            <p style={{ fontSize: "1.1em", lineHeight: "1.6" }}>
              Our Founder has a Masters in Cybersecurity, so you can rest assured your investments are safe. We are 100% Transparent.
            </p>
          </div>
          <div
            style={{
              flex: "1 1 30%",
              textAlign: "center",
              padding: "10px", // Reduced padding for each principle
            }}
          >
            <FaHandsHelping size={50} style={{ marginBottom: "10px" }} />
            <h3 style={{ fontSize: "1.5em", marginBottom: "10px" }}>White Glove Service</h3>
            <p style={{ fontSize: "1.1em", lineHeight: "1.6" }}>
              We are dedicated to delivering you the best investment and rental experience possible.
            </p>
          </div>
        </div>
      </section>

      {/* The GearShare Experience */}
      <section
        style={{
          maxWidth: "1200px",
          margin: "auto",
          display: "flex",
          gap: "40px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: "1 1 50%" }}>
          <h2 style={{ fontSize: "2.2em", marginBottom: "20px" }}>
            The Gier Experience
          </h2>
          <p style={{ fontSize: "1.2em", lineHeight: "1.8" }}>
            Now you can invest in vehicles without having to <strong><em>become a mechanic</em></strong>. 
            You get all of the benefit and convenience of owning luxury, 
            rare or even regular cars from the comfort of your home. Our AI mechanic also makes it easy to manage your own vehicles.
          </p>
          <ul style={{ fontSize: "1.2em", marginTop: "20px", lineHeight: "1.8" }}>
            <li>Monthly returns through rentals or sales.</li>
            <li>Ownership of iconic vehicles, without full financial commitment.</li>
            <li>Complete vehicle management for peace of mind.</li>
          </ul>
        </div>
        <div style={{ flex: "1 1 40%" }}>
          <img
            src={ex2}
            alt="Experience"
            style={{
              width: "100%",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            }}
          />
        </div>
      </section>

      {/* Future Section */}
      <section
        style={{
          textAlign: "center",
          padding: "60px 20px",
          backgroundColor: "#e0e0e0",
          color: "#333",
          marginTop: "40px",
          borderRadius: "10px",
        }}
      >
        <h2 style={{ fontSize: "2.5rem", marginBottom: "20px" }}>
          The Future, Robo Taxis and Autonomous Vehicles
        </h2>
        <p
          style={{
            fontSize: "1.2rem",
            maxWidth: "800px",
            margin: "auto",
            lineHeight: "1.8",
          }}
        >
          In the future many vehicles will be autonomous earning revenue for investors. There will have to be companies to manage the massive scale and size of these vehicles. 
          Even if they are autonomous they will still require constant upkeep, diligent oversight and cleaning. 
          We plan to be one of the companies managing autonomous fleets of vehicles for investors much like property managers manage 
          real estate for investors today.
        </p>
      </section>

{/* The Big Idea Section */}
<section
  style={{
    textAlign: "center",
    padding: "60px 20px",
    background: "linear-gradient(to right,rgb(12, 188, 219), blue,rgb(58, 174, 228))",  // Sides fade effect for depth
    color: "white",
    marginTop: "40px",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.4)"  // Added shadow for depth
  }}
>
  <h2 style={{ fontSize: "2.5rem", marginBottom: "20px" }}>
    The Big Idea
  </h2>
  <p
    style={{
      fontSize: "1.2rem",
      maxWidth: "800px",
      margin: "auto",
      lineHeight: "1.8",
    }}
  >
    FUN FACT: The average age of a vehicle in Cuba is 60 years old.
    <br />
    <br />
    If Cubans are still using cars built in the 1960s, why are we throwing away ours at 100k miles? Many people consider a car old at 100,000 miles and 
    not even worth keeping at 200,000 miles. If we can rent cars over a long period of time, get the whole investment back on the vehicle and more, 
    we can lower the price enough to where it is possible to make it cheaper to rent than to own a vehicle.
    <br />
    <br />
    Yes. You heard that right. We want to make it <strong><em>cheaper to rent a vehicle than to own one.</em></strong>
  </p>
</section>


      {/* Call to Action relocated to the bottom */}
      <section
        style={{
          textAlign: "center",
          padding: "60px 20px",
          backgroundColor: "#1d1e1e",
          color: "white",
          marginTop: "60px",
          borderRadius: "10px",
        }}
      >
        <h2 style={{ fontSize: "2.5rem", marginBottom: "20px" }}>
          Join the Future of Vehicle Investments
        </h2>
        <p style={{ fontSize: "1.4rem", maxWidth: "800px", margin: "auto" }}>
          Discover how Gier is reshaping the way people invest in vehicles.
          Start your journey today and experience the power of real investment vehicles.
        </p>
        <button
          style={{
            marginTop: "30px",
            backgroundColor: "#007bff",
            color: "white",
            padding: "15px 30px",
            fontSize: "1.2em",
            fontWeight: "bold",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Get Started Now
        </button>
      </section>
    </div>
  );
};

export default AboutPage;
